import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const POSScreen = lazy(() => import('./POSScreen'));
const CashDrawer = lazy(() => import('./CashDrawer'));
const POSCustomers = lazy(() => import('./POSCustomers'));
const BackorderManagement = lazy(() => import('./BackorderManagement'));
export const CustomerDisplayScreen = lazy(() => import('./CustomerDisplayScreen'));

export const posRoutes = (
    <React.Fragment key="pos">
        <Route element={<ProtectedRoute permission="pos.sale.view" />}>
            <Route path="/pos" element={<POSScreen />} />
            <Route path="/pos/cash-drawer" element={<CashDrawer />} />
            <Route path="/pos/customers" element={<POSCustomers />} />
        </Route>
        <Route element={<ProtectedRoute permission="pos.sale.manage" />}>
            <Route path="/pos/backorders" element={<BackorderManagement />} />
        </Route>
    </React.Fragment>
);
